export const ENDPOINTS = {
  auth: "/v1/api/auth/user_login",
  auth2: "/v1/api/auth/user_login_v2",
  logout: "/v1/api/auth/logout",
  tokenRenew: "/v1/auth/renew",
  markets: "/bf/markets",
  marketStatus: "/bf/market_status",
  balance: "/v1/user/wallets",
  eventMarket: "/navigation/event-market",
  raceMarket: "/navigation/race-market",
  event: "/navigation/event",
  group: "/navigation/group",
  sports: "/navigation/sports",
  register: "/register",
  placeBet: "/v1/api/bf_placebet",
  marketMatchOdds: "/bf/match-odds-markets",
  bfSportEvents: "/bf/event-type-events",
  bfEventMarkets: "/bf/event-markets",
  inPlayMarkets: "/bf/in-play-markets",
  ip: "/v1/api/ip",
  changePassword: "/v1/api/user/change_password",
  updateLanguage: "/v1/api/users/update_lang",
  snapshot: "/snapshot",
  mktStatus: "/market/status",
  currency: "/v1/api/currency",
  exRate: "/v1/api/exchange_rate",
  todayMarkets: "/bf/today-markets",
  tomorrowMarkets: "/bf/tomorrow-markets",
  betStatus: "/v1/api/bf_bet_status",
  openBets: "/v1/api/bf_open_bets",
  nextEvents: "/bf/next-race",
  cancelBet: "/v1/api/bf_cancelbet",
  myBets: "/v1/api/reports/my_bets",
  myBetsByStatus: "/v1/api/reports/my_bets_v2",
  rate: "/v1/api/exchange_rate/get_by_currency",
  balanceStatement: "/v1/api/reports/balance_statement",
  profitAndLoss: "/v1/api/reports/user_markets",
  profitAndLossDetail: "/v1/api/reports/market_details",
  search: "/navigation/search",
  betsCount: "/v1/api/reports/my_bets/count",
  bfOrderStatus: "/bf/current-user-order",
  userAccount: "/v1/api/users/getById",
  updateAccount: "/v1/api/users/update_profile",
  updateBet: "/v1/api/bf_updatebet",
  betSlipSettings: "/v1/api/white_label/get_bet_configuration",
  updateBetSlipSettings: "/v1/api/users/update_bet_configuration",
  refreshExposure: "/v1/api/refresh_exposure",
  withdrawFunds: "/v1/api/wallet/withdraw",
  featureFlags: "/v1/api/feature-flag",
  sbBmFancyMarket: "/sb/bm-fancy/event",
  sbBm: "/sb/bm/market",
  sbFancy: "/sb/fancy/market",
  maintenanceStatus: "/v1/api/service_config/maintenance",
  navigationList: "/v1/api/navigation_list",
  sbMarkets: "/sb/markets",
  liveMatch: "/live-match",
  userIp: "/x-client",
  mfaSetup: "/2fa/otp/setup",
  mfaVerify: "/2fa/otp/verify",
  failedAttempts: "/v1/api/users/failed_attempts",
  wlMarketConfig: "/v1/api/white_label_market_config",
  wlPermissions: "/v1/api/white_label/get_permission",
  selfRegister: "/v1/api/self_register",
  balanceTransfer: "/v1/api/wallet/internal-transfer",
};
